import { tokens } from "@fluentui/react-components";

export const ResizeHintIcon = () => {
	return (
		<svg
			width="16"
			height="32"
			viewBox="0 0 16 32"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<rect
				x="0.5"
				y="0.5"
				width="15"
				height="31"
				rx="1.5"
				fill={tokens.colorNeutralBackground1Hover}
				stroke={tokens.colorNeutralBackground6}
			/>
			<path
				d="M9 23.3333V8.66667C9 8.29848 9.22386 8 9.5 8C9.74546 8 9.94961 8.23583 9.99194 8.54683L10 8.66667V23.3333C10 23.7015 9.77614 24 9.5 24C9.25454 24 9.05039 23.7642 9.00806 23.4532L9 23.3333V8.66667V23.3333ZM6 23.3333L6 8.66667C6 8.29848 6.22386 8 6.5 8C6.74546 8 6.94961 8.23583 6.99194 8.54683L7 8.66667L7 23.3333C7 23.7015 6.77614 24 6.5 24C6.25454 24 6.05039 23.7642 6.00806 23.4532L6 23.3333L6 8.66667L6 23.3333Z"
				fill={tokens.colorNeutralForeground2}
			/>
		</svg>
	);
};
